<template>
  <header class="header">
    <h3 class="title">{{title}}</h3>
    <div :style="subTitleStyle">
      <slot name="subTitle" />
    </div>

    <p class="location">
      <span class="name">특화 서비스</span>
      <span class="name">&gt; {{title}}</span>
    </p>
    <p class="description">
      <slot name="description" />
    </p>
  </header>
</template>

<script>
export default {
  props: ["title"],
  computed: {
    subTitleStyle() {
      return {
        display: "inline-block",
        paddingTop: "37px",
        fontSize: "13px",
        color: "#333"
      };
    }
  }
};
</script>
